module.exports = __webpack_public_path__ + "static/media/noImage.72bd9290.svg";